import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AttendanceReportCalendar from "./AttendanceReportCalendar";
import SelectInput from "../common/SelectInput";
const AttendanceReportForm = ({
  report,
  onDateChange,
  onSubmit,
  onCancel,
  onSelectClient,
  onSelectTeacher,
  onDateSelection,
  onNavigateFirstCalendar,
  onNavigateSecondCalendar,
  firstCalendarDate,
  secondCalendarDate,
  validateDateOrder,
  handleSelectionState,
  selectionState,
  toggleShowCalendar,
  showCalendar,
  yearOptions,
  monthOptions,
}) => {
  const { startDate, endDate } = report;
  return (
    <div>
      <div className="row justify-content-center d-flex">
        <div className="col-xl-6 col-lg-12 justify-content-start d-flex">
          <h2 className="manage-title w-full mb-3">Raport obecności</h2>
        </div>
      </div>

      <div className="month-range-selector">
        <div className="row justify-content-center d-flex mb-5">
          <div className="col-xl-6 col-lg-12">
            <div className="row">
              <div className="col">
                <SelectInput
                  label="Miesiąc"
                  name="month"
                  value={moment(startDate).month()}
                  onChange={onDateChange}
                  readOnly={false}
                  defaultOption={null}
                  options={monthOptions.map(month => ({
                    value: month.id,
                    text: month.name,
                  }))}
                />
              </div>
              <div className="col">
                <SelectInput
                  label="Rok"
                  name="year"
                  onChange={onDateChange}
                  value={moment(startDate).year()}
                  readOnly={false}
                  defaultOption={null}
                  options={yearOptions.map(year => ({
                    value: year.id,
                    text: year.name,
                  }))}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row date-range-display mb-3 d-flex justify-content-center">
          <h5 className="col-xl-6 col-lg-12 mb-0">
            <div className="row">
              <div className="col-sm-8">
                Wybrano zakres dat: &nbsp;
                <strong>
                  {startDate ? moment(startDate).format("YYYY-MM-DD") : "  "}{" "}
                  &nbsp;-&nbsp;
                  {endDate ? moment(endDate).format("YYYY-MM-DD") : "  "}
                </strong>
              </div>
              <div className="col-sm-4">
                <button
                  className="btn btn-primary w-100 btn-block manage-button"
                  type="button"
                  onClick={toggleShowCalendar}
                >
                  {`Dokładny zakres dat ${showCalendar ? "-" : "+"}`}
                </button>
              </div>
            </div>
          </h5>
        </div>
      </div>
      <div
        id="report-calendar"
        className={`${
          showCalendar ? "mb-3  custom-collapse show" : "custom-collapse"
        }`}
      >
        <AttendanceReportCalendar
          onDateSelection={onDateSelection}
          onNavigateFirstCalendar={onNavigateFirstCalendar}
          onNavigateSecondCalendar={onNavigateSecondCalendar}
          firstCalendarDate={firstCalendarDate}
          secondCalendarDate={secondCalendarDate}
          validateDateOrder={validateDateOrder}
          startDate={report.startDate}
          endDate={report.endDate}
          selectionState={selectionState}
          setSelectionState={handleSelectionState}
        />
      </div>
      <div className="row mb-3 justify-content-center">
        <div className="col-xl-6 col-lg-12">
          <div className="row mb-3 align-items-center">
            <div className="col-sm-8">
              <h5 className="mb-0">
                Wybrano nauczyciela: &nbsp;{" "}
                <strong>{report.teacherName}</strong>
              </h5>
            </div>
            <div className="col-sm-4 text-start align-items-center">
              <button
                type="button"
                className="btn manage-teal-button w-100 btn btn-block manage-button manage-teal-button"
                onClick={() => onSelectTeacher()}
              >
                Wybierz nauczyciela
              </button>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-sm-8">
              <h5 className="mb-0">
                Wybrano klienta: &nbsp; <strong>{report.clientName}</strong>
              </h5>
            </div>
            <div className="col-sm-4 text-start align-items-center">
              <button
                type="button"
                className="btn manage-teal-button w-100 btn btn-block manage-button manage-teal-button"
                onClick={() => onSelectClient()}
              >
                Wybierz Klienta
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className=" mt-4 row justify-content-center">
        <form
          id="attendance-report-form"
          onSubmit={onSubmit}
          className="col-6 mt-4"
        >
          <div className="row">
            <div className="col">
              <button
                type="submit"
                className="btn w-100 btn btn-block manage-button btn-success"
              >
                Wygeneruj raport
              </button>
            </div>
            <div className="col">
              <button
                type="button"
                className="btn w-100 btn btn-block manage-button manage-red-button"
                onClick={onCancel}
              >
                Anuluj
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

AttendanceReportForm.propTypes = {
  report: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSelectClient: PropTypes.func.isRequired,
  onSelectTeacher: PropTypes.func.isRequired,
  onDateSelection: PropTypes.func.isRequired,
  onNavigateFirstCalendar: PropTypes.func.isRequired,
  onNavigateSecondCalendar: PropTypes.func.isRequired,
  firstCalendarDate: PropTypes.instanceOf(Date).isRequired,
  secondCalendarDate: PropTypes.instanceOf(Date).isRequired,
  validateDateOrder: PropTypes.func.isRequired,
  handleSelectionState: PropTypes.func.isRequired,
  selectionState: PropTypes.number.isRequired,
  toggleShowCalendar: PropTypes.func.isRequired,
  showCalendar: PropTypes.bool.isRequired,
  yearOptions: PropTypes.array.isRequired,
  monthOptions: PropTypes.array.isRequired,
};

export default AttendanceReportForm;
